import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Zahlarten')
    .setRoute('payment_type_list')
    .setAdditionalRoutes([
        'payment_type_edit',
    ]);
